import React, { useState } from "react";
import popupsyle from "../../../style/PopUp.module.css";
import Style from "../../../style/Pages/PopUp/ViewGroupPopUp.module.css";
import { TfiClose } from "react-icons/tfi";
import { PiDotsThreeOutlineVerticalThin } from "react-icons/pi";
import MainStyle from "../../../style/Main.module.css";
import { useFetchGroupById, useGroupEditAction } from "../../../hooks/useGroup";
import { getRegisterId } from "../../../utils/authId";
import { FiEdit2, FiUserPlus } from "react-icons/fi";
import EditGroupNmOrLogo from "./EditGroupNmOrLogo";
import FallbackAvatar from "../../../components/ui/FallbackAvatar/FallbackAvatar";
import InvitePopup from "./InvitePopUp";
import { getUserDetails } from "../../../utils/auth";
import { groupEdit } from "../../../routes/AccessCondition";

const ViewGroupPopUp = ({ onClose, groupId, updated }) => {
  const {
    selectedGroup,
    loading: groupLoading,
    refresh: refreshGroup,
  } = useFetchGroupById(groupId);
  const steps = ["Members"];
  const [activeStep, setActiveStep] = useState(0);
  const apiUrl = process.env.REACT_APP_API_URL;
  const loggedInUserId = getRegisterId();
  const [isEditingName, setIsEditingName] = useState(false);
  const [showInvitePopup, setShowInvitePopup] = useState(false);
  // const [imgError, setImgError] = useState(false);

  const {
    id,
    group_name,
    group_icon,
    company,
    // group_admin_details = [],
    group_user_details = [],
  } = selectedGroup[0] || {};

  const { editGroupAction } = useGroupEditAction(id);
  // const managerIds = group_admin_details.map((manager) => manager.id);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const user = getUserDetails() || {};
  const editAccess = groupEdit();

  const toggleDropdown = (userId) => {
    setActiveDropdown(activeDropdown === userId ? null : userId);
  };
  // const handleMakeManager = async (userId) => {
  //   // console.log(`Making user ${userId} a channel manager`);
  //   try {
  //     await editGroupAction({ add_group_admin: [userId] });
  //     setActiveDropdown(null);
  //     refreshGroup();
  //     updated();
  //   } catch (error) {
  //     throw error;
  //   }
  // };
  // const handleRemoveManager = async (userId) => {
  //   // console.log(`Making user ${userId} a channel manager`);
  //   try {
  //     await editGroupAction({ leave_group_admin: userId });
  //     setActiveDropdown(null);
  //     refreshGroup();
  //     updated();
  //   } catch (error) {
  //     throw error;
  //   }
  // };

  const handleRemoveMember = async (userId) => {
    // console.log(`Removing user ${userId}`);
    try {
      await editGroupAction({ leave_group_user: userId });
      setActiveDropdown(null);
      refreshGroup();
      updated();
    } catch (error) {
      throw error;
    }
  };

  const handleUpdated = () => {
    refreshGroup();
    updated();
  };

  const ShimmerLoader = () => (
    <div className={Style.ViewGroupDetail}>
      <div className={popupsyle.PopupContainer}>
        <div className={Style.popupHeader}>
          <div className={Style.NamendImage}>
            <div
              className={`${Style.shimmer} ${Style.circle} ${Style.GroupLogoShimmer}`}
            ></div>
            <div className={Style.GroupInfo}>
              <div
                className={`${Style.shimmer} ${Style.line} ${Style.GroupNameShimmer}`}
              ></div>
            </div>
          </div>
          <div
            className={`${Style.shimmer} ${Style.circle}`}
            style={{ width: "24px", height: "24px" }}
          ></div>
        </div>

        <div className={Style.popupContent}>
          <div className={Style.ViewGroupStepper}>
            {steps.map((_, index) => (
              <div key={index} className={Style.ViewGroupStep}>
                <div
                  className={`${Style.shimmer} ${Style.line} ${Style.StepLabelShimmer}`}
                  style={{ width: "60px", marginBottom: "4px" }}
                ></div>
                <div className={Style.ViewGroupStepLine}></div>
              </div>
            ))}
          </div>

          <div className={Style.MembersContainer}>
            <div className={Style.MembersHeader}>
              <div
                className={`${Style.shimmer} ${Style.line} ${Style.MemberCountShimmer}`}
                style={{ width: "120px" }}
              ></div>
              <div
                className={`${Style.shimmer} ${Style.rectangle} ${Style.InviteButtonShimmer}`}
              ></div>
            </div>

            <div className={Style.MembersList}>
              <div className={Style.ScrollableMemberList}>
                {/* Render 5 shimmer member items */}
                {[...Array(5)].map((_, index) => (
                  <div key={index} className={Style.MemberItem}>
                    <div className={Style.MemberInfo}>
                      <div className={MainStyle.ImageWrapper}>
                        <div
                          className={`${Style.shimmer} ${Style.circle} ${Style.AvatarShimmer}`}
                        ></div>
                      </div>
                      <div className={Style.MemberDetails}>
                        <div
                          className={`${Style.shimmer} ${Style.line} ${Style.NameShimmer}`}
                          style={{ width: "100px", marginBottom: "6px" }}
                        ></div>
                        <div
                          className={`${Style.shimmer} ${Style.line} ${Style.AboutShimmer}`}
                          style={{ width: "150px" }}
                        ></div>
                      </div>
                    </div>
                    <div className={Style.MemberActions}>
                      <div
                        className={`${Style.shimmer} ${Style.circle}`}
                        style={{ width: "24px", height: "24px" }}
                      ></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  if (groupLoading) {
    return (
      <div className={popupsyle.popupBackground}>
        <ShimmerLoader />
      </div>
    );
  }
  return (
    <div className={popupsyle.popupBackground}>
      <div className={Style.ViewGroupDetail}>
        <div className={popupsyle.PopupContainer}>
          <div className={Style.popupHeader}>
            <div className={Style.NamendImage}>
              {group_icon !== null ? (
                <img
                  className={Style.GroupLogo}
                  src={`${apiUrl}${group_icon}`}
                  alt={group_name}
                />
              ) : (
                <FallbackAvatar name={group_name} size={36} />
              )}

              <div className={Style.GroupInfo}>
                {/* <h3>{group_name}</h3> */}

                <h2 className={Style.groupnameh2}>{group_name}</h2>

                {/* <p className={Style.GroupTopic}>
                  {channel_topic || "No topic set"}
                </p> */}
              </div>
              {user.role !== "staff" &&
                (user.role === "admin" ? (
                  <FiEdit2 size={14} onClick={() => setIsEditingName(true)} />
                ) : (
                  user.role === "other_user" &&
                  editAccess && (
                    <FiEdit2 size={14} onClick={() => setIsEditingName(true)} />
                  )
                ))}
            </div>
            <TfiClose size={18} onClick={onClose} />
          </div>

          <div className={Style.popupContent}>
            <div className={Style.ViewGroupStepper}>
              {steps.map((label, index) => (
                <button
                  key={index}
                  className={`${Style.ViewGroupStep} ${
                    activeStep === index ? Style.activeStep : ""
                  }`}
                  onClick={() => setActiveStep(index)}
                >
                  <div className={Style.ViewGroupStepLabel}>{label}</div>
                  <div className={Style.ViewGroupStepLine}></div>
                </button>
              ))}
            </div>

            {/* {activeStep === 0 ? ( */}
            <div className={Style.MembersContainer}>
              <div className={Style.MembersHeader}>
                <h4>Members ({group_user_details.length})</h4>
                {user.role !== "staff" &&
                  (user.role === "admin" ? (
                    <button
                      className={Style.inviteButton}
                      onClick={() => setShowInvitePopup(true)}
                    >
                      <FiUserPlus size={16} />
                      <span>Invite</span>
                    </button>
                  ) : (
                    user.role === "other_user" &&
                    editAccess && (
                      <button
                        className={Style.inviteButton}
                        onClick={() => setShowInvitePopup(true)}
                      >
                        <FiUserPlus size={16} />
                        <span>Invite</span>
                      </button>
                    )
                  ))}
              </div>

              <div className={Style.MembersList}>
                <div className={Style.ScrollableMemberList}>
                  {group_user_details.map((people) => (
                    <div key={people.id} className={Style.MemberItem}>
                      <div className={Style.MemberInfo}>
                        <div className={MainStyle.ImageWrapper}>
                          {people.emp_pic ? (
                            <img
                              className={Style.ProfileView}
                              src={`${apiUrl}${people.emp_pic}`}
                              alt={`${people.first_name} ${people.last_name}`}
                            />
                          ) : (
                            <FallbackAvatar
                              name={people.first_name}
                              size={36}
                            />
                          )}

                          <span
                            className={
                              people.online_status
                                ? MainStyle.OnlineIndicator
                                : MainStyle.OfflineIndicator
                            }
                          ></span>
                        </div>
                        <div className={Style.MemberDetails}>
                          <p className={Style.peopleName}>
                            {people.id === loggedInUserId
                              ? `${people.first_name} ${people.last_name} (You)`
                              : `${people.first_name} ${people.last_name}`}
                          </p>
                          <p className={Style.about}>
                            {people.about || "No status"}
                          </p>
                        </div>
                      </div>

                      <div className={Style.MemberActions}>
                        {/* {managerIds.includes(people.id) && (
                          <span className={Style.MemberRole}>Admin</span>
                        )} */}
                        {user.role !== "staff" &&
                          (user.role === "admin" &&
                          loggedInUserId !== people.id ? (
                            <div className={Style.Dropdown}>
                              <button
                                className={Style.DropdownToggle}
                                onClick={() => toggleDropdown(people.id)}
                              >
                                <PiDotsThreeOutlineVerticalThin size={18} />
                              </button>
                              {activeDropdown === people.id && (
                                <div className={Style.DropdownMenu}>
                                  <button
                                    onClick={() =>
                                      handleRemoveMember(people.id)
                                    }
                                    className={`${Style.DropdownItem} ${Style.dangerItem}`}
                                  >
                                    Remove from group
                                  </button>
                                </div>
                              )}
                            </div>
                          ) : (
                            user.role === "other_user" &&
                            editAccess &&
                            loggedInUserId !== people.id && (
                              <div className={Style.Dropdown}>
                                <button
                                  className={Style.DropdownToggle}
                                  onClick={() => toggleDropdown(people.id)}
                                >
                                  <PiDotsThreeOutlineVerticalThin size={18} />
                                </button>
                                {activeDropdown === people.id && (
                                  <div className={Style.DropdownMenu}>
                                    <button
                                      onClick={() =>
                                        handleRemoveMember(people.id)
                                      }
                                      className={`${Style.DropdownItem} ${Style.dangerItem}`}
                                    >
                                      Remove from group
                                    </button>
                                  </div>
                                )}
                              </div>
                            )
                          ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isEditingName && (
        <EditGroupNmOrLogo
          groupId={groupId}
          Onclose={() => setIsEditingName(false)}
          updated={handleUpdated}
        />
      )}
      {showInvitePopup && (
        <InvitePopup
          onClose={() => setShowInvitePopup(false)}
          Id={id}
          company={company[0]}
          Updated={handleUpdated}
          OpenFrom={"group"}
          PeopleId={group_user_details}
        />
      )}

      {}
    </div>
  );
};

export default ViewGroupPopUp;
